import { useDomainAccessControl } from './utils/domain/accessControl'
import {
  adminStorefrontSetupViewAccessControl,
  onboardingSiteSetupChecklistAccessControl,
} from './access-control/onboardingAccess.configuration.ts'

export { usePendingPartnerOnboardingRedirection } from './utils/usePendingPartnerOnboardingRedirection.hooks'
export { useHideNavbarDueToPendingOnboarding } from './utils/useHideNavbarDueToPendingOnboarding.hooks'
export { OnboardingSiteSetupChecklistGroup } from './components/site-setup-checklist-group/OnboardingSiteSetupChecklistGroup'

// This is to check whether we should display the site setup checklist for a retailer/warehouse/banner
export const useHasSiteSetupChecklistAccess = () =>
  useDomainAccessControl()(onboardingSiteSetupChecklistAccessControl)

// This is to check whether the site setup features should be visible to the IPP user
export const useHasSiteSetupAccess = () =>
  useDomainAccessControl()(adminStorefrontSetupViewAccessControl)
